"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useComponentStyles = void 0;
var React = __importStar(require("react"));
var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
var PauseCircleFilled_1 = __importDefault(require("@material-ui/icons/PauseCircleFilled"));
var PlayCircleFilledWhite_1 = __importDefault(require("@material-ui/icons/PlayCircleFilledWhite"));
var Replay_1 = __importDefault(require("@material-ui/icons/Replay"));
var classnames_1 = __importDefault(require("classnames"));
var player_1 = __importDefault(require("./state/player"));
exports.useComponentStyles = makeStyles_1.default({
    icon: function (props) { return ({
        color: props.playerColors.active,
        '&:hover': {
            color: props.playerColors.hover,
        },
    }); },
});
var AudioPlayControl = function (_a) {
    var playerStatus = _a.playerStatus, playerColors = _a.playerColors, pauseAudio = _a.pauseAudio, playAudio = _a.playAudio, replayAudio = _a.replayAudio, _b = _a.icons, icons = _b === void 0 ? {} : _b, _c = _a.classNames, classNames = _c === void 0 ? {} : _c;
    var _d = icons.PlayIcon, PlayIcon = _d === void 0 ? PlayCircleFilledWhite_1.default : _d, _e = icons.ReplayIcon, ReplayIcon = _e === void 0 ? Replay_1.default : _e, _f = icons.PauseIcon, PauseIcon = _f === void 0 ? PauseCircleFilled_1.default : _f;
    var classes = exports.useComponentStyles({ playerColors: playerColors });
    switch (playerStatus) {
        case player_1.default.STATUS.PLAY:
            return (React.createElement(PauseIcon, { fontSize: "large", onClick: pauseAudio, className: classnames_1.default(classes.icon, classNames.pauseIcon) }));
        case player_1.default.STATUS.STOP:
            return (React.createElement(ReplayIcon, { fontSize: "large", onClick: replayAudio, className: classnames_1.default(classes.icon, classNames.replayIcon) }));
        default:
            return (React.createElement(PlayIcon, { fontSize: "large", onClick: playAudio, className: classnames_1.default(classes.icon, classNames.playIcon) }));
    }
};
exports.default = React.memo(AudioPlayControl);
//# sourceMappingURL=AudioPlayControl.js.map